module.exports = girder_plugin_slicer_cli_web;


//////////////////
// WEBPACK FOOTER
// external "girder_plugin_slicer_cli_web"
// module id = 2
// module chunks = 0